import { injectReducer } from 'store/reducers'

export default (store) => ({
  path: 'team/:teamId/license',
  /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([
      './containers/TeamLicenseContainer',
      './modules/teamLicense'
    ], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const ParticipantUpload = require('./containers/TeamLicenseContainer').default
      const actions = require('./modules/teamLicense')
      const reducer = require('./modules/teamLicense').default

      /*  Add the reducer to the store on key named below*/
      injectReducer(store, { key: 'teamLicense', reducer: reducer })

      store.dispatch(actions.fetchData(nextState.params.teamId))

      /*  Return getComponent   */
      cb(null, ParticipantUpload)

    /* Webpack named bundle   */
    }, 'teamLicense')
  }
})



// WEBPACK FOOTER //
// ./src/routes/TeamLicense/index.js